import { render, staticRenderFns } from "./RemoteFolderConfigurationDetails.vue?vue&type=template&id=da83c7ac&"
import script from "./RemoteFolderConfigurationDetails.vue?vue&type=script&lang=js&"
export * from "./RemoteFolderConfigurationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports